import React, { useState, useEffect } from "react";
import { Drawer, IconButton, List } from "@material-ui/core";
import {
 DashboardOutlined,
 Home as HomeIcon, 
 ArrowBackIosOutlined as ArrowBackIcon, 
} from "@material-ui/icons";
import { useTheme } from "@material-ui/styles";
import { withRouter, useParams } from "react-router-dom";
import classNames from "classnames";
import Cookies from 'universal-cookie';

// styles
import useStyles from "./styles";

// components
import SidebarLink from "./components/SidebarLink/SidebarLink";
import Dot from "./components/Dot";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../context/LayoutContext";


function getIconFromType(type){
  return <HomeIcon />;
}



function AccountSideBar({ location, ...props }) {
  var classes = useStyles();
  var theme = useTheme();

  //var props = useParams();

  // global
  var { isSidebarOpened } = useLayoutState();
  var layoutDispatch = useLayoutDispatch();

  // local
  var [isPermanent, setPermanent] = useState(true);

  useEffect(function() {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  //let menuItems = JSON.parse(props);

  let jsonItems = [];
  try {
    jsonItems = props.menuItems;
  }
  catch (error){}

  const cookies = new Cookies();
  const username = cookies.get('username', { path: '/' });
  const token = cookies.get('token', { path: '/' });
  const userType = cookies.get('userType', { path: '/' });
  const brokerType = cookies.get('brokerType', { path: '/' });
  
  let structure = [
    { id: 1, label: "La tua demo", link: "/main/account", icon: <DashboardOutlined /> },
  ];

  return (
    <Drawer
      variant={isPermanent ? "permanent" : "temporary"}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        }),
      }}
      open={isSidebarOpened}
    style={{position: 'sticky'}}

    >
      <div className={classes.toolbar} />
      <div className={classes.mobileBackButton}>
        <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
          <ArrowBackIcon
            classes={{
              root: classNames(classes.headerIcon, classes.headerIconCollapse),
            }}
          />
        </IconButton>
      </div>
      <List className={classes.sidebarList} >
        <img alt="" src={ require('../../images/icon.png') } style={{ alignSelf: 'center', marginTop: 30, marginBottom: 30, maxWidth: '30%', marginLeft: '35%' }} />
        {structure.map(link => (
          <SidebarLink
            key={link.id}
            location={location}
            isSidebarOpened={isSidebarOpened}
            {...link}
          />
        ))}
      </List>
    </Drawer>
  );

  // ##################################################################
  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    var breakpointWidth = theme.breakpoints.values.md;
    var isSmallScreen = windowWidth < breakpointWidth;

    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }
}

export default withRouter(AccountSideBar);
